export const allArticles = [
  {
    slug: "japanese-craftsmanship-spirit",
    title: "日本匠人精神：探索极致工艺背后的故事",
    excerpt: "从一把折扇到一件陶瓷，日本匠人用一生追求极致完美。深入探访京都老铺，了解传承数百年的手工艺精神与亚洲精品理念。",
    image: "https://readdy.ai/api/search-image?query=Japanese%20artisan%20working%20on%20traditional%20craft%20in%20workshop%2C%20warm%20natural%20light%20from%20window%2C%20elegant%20documentary%20photography%20with%20cream%20tones&width=1200&height=675&seq=article-detail-01&orientation=landscape",
    category: "工艺",
    date: "2026-08-10",
    readTime: "8分钟",
    author: "亚洲精品编辑部",
    content: `
      <h2>匠人精神：一生只做一件事</h2>
      <p>在日本京都的深巷中，藏匿着许多传承数百年的老铺。这些店铺往往只有几平方米的空间，却承载着一个家族几代人的心血与智慧。日本匠人精神——"一生悬命"，意为用一生的时间专注于一件事，追求极致完美。</p>
      <p>京都的"西阵织"工匠佐藤先生，已经从事传统织造工作超过五十年。他的双手在经纬之间穿梭，每一寸织物都凝聚着数十年的功力。佐藤先生说："机器可以在一天内完成我一周的工作量，但它永远无法替代手感。真正的亚洲精品，是需要匠人用灵魂去感知的。"</p>
      
      <h2>从原材料到成品：每一道工序都是艺术品</h2>
      <p>日本传统工艺的特点在于对细节的极致追求。以一把京都折扇为例，从选竹、削骨、贴纸到绘饰，需要经过二十多道工序，全部由匠人手工完成。每一根扇骨的弧度、间距都经过精确的计算和反复的调整。</p>
      <p>这种对品质的执着，正是亚洲精品的核心价值所在。我们不追求数量，而追求每一件产品都能成为传世之作。</p>
      
      <h2>现代与传统：创新中的传承</h2>
      <p>值得注意的是，日本的传统工艺并非固步自封。许多新一代匠人在继承传统的基础上，融入了现代设计理念。他们将传统工艺与现代审美相结合，创造出既保留文化底蕴又符合当代生活需求的亚洲精品。</p>
      <p>例如，京都的"清水烧"陶瓷品牌，在保留传统釉色的同时，推出了更加简约现代的器型设计。这些作品不仅在日本国内受到欢迎，也在国际上获得了广泛认可。</p>
      
      <h2>亚洲精品的启示</h2>
      <p>日本匠人精神给我们的启示是：真正的品质来自于专注和坚持。在这个追求速度和效率的时代，那些愿意慢下来、用心打磨产品的匠人和品牌，才是亚洲精品最宝贵的财富。</p>
    `,
  },
  {
    slug: "korean-skincare-secrets",
    title: "韩国护肤秘笈：从传统韩方到现代K-Beauty",
    excerpt: "韩国美妆产业如何将千年草本智慧与现代科技完美融合？深度解析韩方护肤品的研发历程与亚洲精品品质标准。",
    image: "https://readdy.ai/api/search-image?query=Korean%20skincare%20ingredients%20with%20natural%20herbs%20on%20marble%2C%20elegant%20beauty%20photography%20with%20cream%20background%20and%20soft%20lighting&width=1200&height=675&seq=article-detail-02&orientation=landscape",
    category: "美妆",
    date: "2026-08-08",
    readTime: "6分钟",
    author: "亚洲精品编辑部",
    content: `
      <h2>韩方护肤的千年根基</h2>
      <p>韩国护肤品的成功并非偶然。早在朝鲜王朝时期，宫廷中就已经开始使用人参、当归、白芷等中药材进行肌肤护理。"韩方"（Hanbang）护肤理念的核心是"以内养外"，强调从根源调理肌肤状态。</p>
      <p>在现代K-Beauty产业中，许多品牌依然坚持使用韩方理念。他们将传统草本配方与先进的生物萃取技术相结合，创造出既安全又高效的亚洲精品护肤品。</p>
      
      <h2>科技赋能传统智慧</h2>
      <p>现代韩国护肤品之所以能够风靡全球，关键在于其对科研的重视。韩国美妆企业每年投入巨额资金用于研发，许多品牌拥有自己的实验室和科研团队。他们将发酵技术、纳米技术等前沿科技应用于传统草本成分的提取和稳定化处理。</p>
      <p>例如，红参精华的提取过程中，采用低温酶解技术可以最大限度地保留活性成分，使产品功效提升数倍。这种科技与传统的结合，正是亚洲精品护肤品的核心竞争力。</p>
      
      <h2>从韩国到世界：K-Beauty的全球化之路</h2>
      <p>韩国美妆产品的全球化并非一蹴而就。从最初在亚洲市场的成功，到如今在欧美市场的广泛认可，韩国护肤品凭借其高品质和创新力赢得了全球消费者的信赖。这也为其他亚洲国家的美妆品牌提供了宝贵的经验。</p>
    `,
  },
  {
    slug: "chinese-tea-culture-guide",
    title: "中国茶文化品鉴指南：从龙井到普洱的极致体验",
    excerpt: "一杯好茶，一方天地。带你走进中国茶文化的世界，了解各大名茶的品鉴之道与选购亚洲精品茶叶的秘诀。",
    image: "https://readdy.ai/api/search-image?query=Chinese%20tea%20ceremony%20with%20elegant%20teaware%20on%20wooden%20table%2C%20warm%20cream%20background%2C%20serene%20cultural%20photography%20with%20soft%20natural%20light&width=1200&height=675&seq=article-detail-03&orientation=landscape",
    category: "食品",
    date: "2026-08-05",
    readTime: "10分钟",
    author: "亚洲精品编辑部",
    content: `
      <h2>中国茶：五千年的文化符号</h2>
      <p>茶，是中国人生活中不可或缺的一部分。从神农尝百草的神话传说，到陆羽的《茶经》，再到如今遍布全球的茶文化，中国茶已经走过了五千年的历史长河。每一种名茶背后，都有着独特的地理环境、制作工艺和文化故事。</p>
      
      <h2>龙井：绿茶之冠</h2>
      <p>西湖龙井，产于浙江杭州西湖周边，以其"色绿、香郁、味甘、形美"四绝著称于世。真正的顶级龙井茶，采摘时间极为讲究——以清明前采摘的"明前茶"最为珍贵。一斤上好的明前龙井，需要采摘数万个嫩芽，经过杀青、揉捻、干燥等多道工序精心制作。</p>
      <p>品鉴龙井，水温控制在80℃左右最为适宜。初泡时，茶叶在杯中舒展如兰花绽放，清香四溢；品之，鲜爽回甘，余韵悠长。这正是亚洲精品茶叶的极致魅力。</p>
      
      <h2>普洱：可饮用的古董</h2>
      <p>普洱茶是唯一一种越陈越香的中国茶。产自云南的普洱茶分为生普和熟普两种，经过岁月的沉淀，茶叶中的物质发生复杂的化学变化，风味愈发醇厚。</p>
      <p>收藏普洱茶已经成为一种投资方式和文化现象。一块保存良好的百年老茶，其价值可以媲美顶级红酒。这也是亚洲精品茶叶的独特魅力所在。</p>
      
      <h2>如何选购优质茶叶</h2>
      <p>选购亚洲精品茶叶，需要关注以下几个要点：首先是产地，正宗的核心产区是品质的基础；其次是工艺，传统手工制作往往优于机械化生产；再次是品牌信誉，有传承的老字号更值得信赖；最后是个人口感，好的茶叶最终要适合自己的品味偏好。</p>
    `,
  },
  {
    slug: "thai-wellness-wisdom",
    title: "泰国养生智慧：从泰式按摩到天然草本的疗愈之道",
    excerpt: "泰国的养生文化源远流长，融合了佛教哲学、传统医学和自然疗法。探索泰国如何将古老智慧转化为现代人需要的亚洲精品养生体验。",
    image: "https://readdy.ai/api/search-image?query=Thai%20wellness%20spa%20with%20natural%20herbs%20and%20essential%20oils%20on%20cream%20background%2C%20serene%20aromatherapy%20photography%20with%20soft%20natural%20light&width=1200&height=675&seq=article-detail-04&orientation=landscape",
    category: "美妆",
    date: "2026-08-02",
    readTime: "7分钟",
    author: "亚洲精品编辑部",
    content: `
      <h2>泰国养生文化的独特之处</h2>
      <p>泰国的养生文化深受佛教哲学和印度阿育吠陀医学的影响。泰国人相信身心平衡是健康的基础，而这种平衡可以通过草药、按摩、冥想和饮食来实现。</p>
      <p>在泰国，几乎每个家庭都会使用传统的草药配方来应对日常的小毛病。这些世代相传的智慧，如今已经被现代品牌开发成了一系列亚洲精品养生和护肤产品。</p>
      
      <h2>泰式精油：大自然的馈赠</h2>
      <p>泰国丰富的热带植物资源为精油产业提供了得天独厚的条件。柠檬草、依兰依兰、姜黄、青柠——这些泰国本土植物萃取的天然精油，不仅香气宜人，更具有显著的疗愈功效。</p>
      <p>优质的泰国精油品牌严格遵循传统工艺，采用冷压或蒸馏方式提取精油，保留植物的完整活性成分。这种对品质的坚持，正是亚洲精品的核心理念。</p>
    `,
  },
  {
    slug: "indian-textile-art",
    title: "印度纺织艺术：千年手工技艺的色彩盛宴",
    excerpt: "印度的纺织传统可以追溯到五千年前。从克什米尔的羊绒披肩到拉贾斯坦的版染印花，探索这个色彩之国的亚洲精品纺织艺术。",
    image: "https://readdy.ai/api/search-image?query=Indian%20traditional%20handwoven%20textiles%20with%20vibrant%20colors%20on%20cream%20background%2C%20artisan%20fabric%20photography%20with%20warm%20soft%20light&width=1200&height=675&seq=article-detail-05&orientation=landscape",
    category: "时尚",
    date: "2026-07-28",
    readTime: "9分钟",
    author: "亚洲精品编辑部",
    content: `
      <h2>印度纺织：一部流动的文明史</h2>
      <p>印度的纺织传统是这个古老文明最绚丽的文化遗产之一。从摩亨佐达罗遗址中出土的棉纺痕迹可以看出，印度人早在五千年前就已经掌握了先进的纺织技术。今天，印度各地的纺织工艺依然鲜活地传承着。</p>
      
      <h2>克什米尔羊绒：软黄金的传奇</h2>
      <p>克什米尔地区的羊绒披肩被誉为"软黄金"。这种披肩使用当地高山山羊的细绒手工编织而成，一条上等的羊绒披肩需要工匠花费数月时间才能完成。其质地轻盈柔软，却具有极佳的保暖效果，是亚洲精品纺织艺术的巅峰代表。</p>
    `,
  },
  {
    slug: "vietnamese-lacquer-craft",
    title: "越南漆器之美：千年磨砺的东方艺术瑰宝",
    excerpt: "越南漆器以其独特的光泽和精湛的工艺闻名于世。深入了解这门传承千年的亚洲精品手工艺，感受每一件漆器背后的匠心故事。",
    image: "https://readdy.ai/api/search-image?query=Vietnamese%20lacquer%20art%20pieces%20on%20display%20in%20workshop%2C%20elegant%20craft%20photography%20with%20warm%20cream%20background%20and%20soft%20lighting&width=1200&height=675&seq=article-detail-06&orientation=landscape",
    category: "工艺",
    date: "2026-07-22",
    readTime: "6分钟",
    author: "亚洲精品编辑部",
    content: `
      <h2>越南漆器的历史渊源</h2>
      <p>越南漆器工艺（Sơn Mài）可以追溯到两千多年前。漆树在越南的气候条件下生长良好，为这门工艺提供了优质的原材料。越南工匠将天然漆液与矿物颜料混合，经过层层涂刷、打磨和抛光，创造出光泽深邃的漆器艺术品。</p>
      <p>传统的越南漆器通常以黑、红、金三色为主，这些色彩在越南文化中具有重要的象征意义——黑色代表大地和永恒，红色象征生命和繁荣，金色则寓意尊贵和神圣。</p>
      
      <h2>匠心工艺的极致呈现</h2>
      <p>一件高品质的越南漆器作品，制作周期通常需要数周到数月。工匠首先在木胎上裱布、刮灰，然后涂刷多层底漆。每上一层漆都需要在特定的湿度和温度条件下阴干，然后用水砂纸反复打磨。最后还要进行抛光处理，才能呈现出越南漆器标志性的镜面光泽。</p>
      <p>这种耗时费力的工艺过程，正是亚洲精品所推崇的匠心精神的完美体现。</p>
    `,
  },
];

export const articlesByCategory = (category: string) => {
  if (category === "all") return allArticles;
  return allArticles.filter((a) => a.category === category);
};

export const getArticleBySlug = (slug: string) => {
  return allArticles.find((a) => a.slug === slug) || null;
};

export const articleCategories = ["全部", "时尚", "美妆", "食品", "工艺"];